import { ContentBlockWrapper } from "../../components/markdown/ContentBlockWrapper";
import { MarkdownContentContext } from "../../components/markdown/MarkdownContentContext";
import { useMarkdownStyle } from "../../components/markdown/MarkdownStyleContext";
import { sameNodePosition } from "../../components/markdown/utils";
import { cva } from "class-variance-authority";
import React, { memo, useContext, useMemo } from "react";
export const blockquoteVariants = cva(["w-full text-base italic p-3", "relative", "before:content-[''] before:absolute before:left-0 before:top-3 before:bottom-3", "before:w-1 before:bg-faint", "before:rounded-full"], {
  variants: {
    variant: {
      surface: ["text-foreground", "bg-transparent"]
    },
    buttonDisplay: {
      inside: ["pr-12"],
      outside: []
    }
  }
});
/**
 * Renders blockquotes inside Markdown output, with a vertical accent bar and,
 * when `canCopyQuotes` is enabled via MarkdownStyleContext, a copy button that
 * extracts the raw quote text from the source content.
 * @summary Blockquote renderer for Markdown.
 */
export const BlockquoteBlock = memo(({
  children,
  variant = "surface",
  node
}) => {
  const {
    canCopyQuotes
  } = useMarkdownStyle();
  const {
    content
  } = useContext(MarkdownContentContext);
  const buttonDisplay = canCopyQuotes ? "inside" : null;
  const clipboardContent = useMemo(() => {
    if (!(node !== null && node !== void 0 && node.position)) {
      return undefined;
    }
    const lines = content.split("\n");
    // hast positions are 1-indexed; end.line is the last line (inclusive).
    const blockquoteLines = lines.slice(node.position.start.line - 1, node.position.end.line);
    // Strip the leading "> " blockquote markers to get the raw content.
    const stripped = blockquoteLines.map(line => line.replace(/^>\s?/, "")).join("\n");
    return stripped ? {
      "text/plain": stripped
    } : undefined;
  }, [content, node]);
  return /*#__PURE__*/React.createElement(ContentBlockWrapper, {
    content: clipboardContent,
    className: "my-2",
    buttonDisplay: buttonDisplay
  }, /*#__PURE__*/React.createElement("blockquote", {
    className: blockquoteVariants({
      variant,
      buttonDisplay
    })
  }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node) && prev.variant === next.variant);
BlockquoteBlock.displayName = "BlockquoteBlock";
//# sourceMappingURL=BlockquoteBlock.js.map